import './MainLogo.css';
import videoLogo from '../../../../src/images/video-logo.svg';
import { NavigateFunction } from 'react-router-dom';

interface Props {
  nav: NavigateFunction;
}

function MainLogo({ nav }: Props): JSX.Element {
  return (
    <div
      className="LogoContainer"
      onClick={() => {
        nav('/');
      }}
    >
      <img src={videoLogo} alt="Video Logo" />
    </div>
  );
}

export default MainLogo;
